/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Ticket_Not_Found_TitleInputs */

const en_verify_ticket_not_found_title = /** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket Not Found`)
};

const es_verify_ticket_not_found_title = /** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket No Encontrado`)
};

const fr_verify_ticket_not_found_title = /** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket introuvable`)
};

const de_verify_ticket_not_found_title = /** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket nicht gefunden`)
};

const id_verify_ticket_not_found_title = /** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiket Tidak Ditemukan`)
};

/** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */
const ja_verify_ticket_not_found_title = en_verify_ticket_not_found_title;

/** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */
const zh_verify_ticket_not_found_title = en_verify_ticket_not_found_title;

/** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */
const ar_verify_ticket_not_found_title = en_verify_ticket_not_found_title;

/** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */
const it_verify_ticket_not_found_title = en_verify_ticket_not_found_title;

/** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */
const ru_verify_ticket_not_found_title = en_verify_ticket_not_found_title;

/** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */
const pt_verify_ticket_not_found_title = en_verify_ticket_not_found_title;

/** @type {(inputs: Verify_Ticket_Not_Found_TitleInputs) => LocalizedString} */
const ko_verify_ticket_not_found_title = en_verify_ticket_not_found_title;

/**
* | output |
* | --- |
* | "Ticket Not Found" |
*
* @param {Verify_Ticket_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_ticket_not_found_title = /** @type {((inputs?: Verify_Ticket_Not_Found_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Ticket_Not_Found_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_ticket_not_found_title(inputs)
	if (locale === "es") return es_verify_ticket_not_found_title(inputs)
	if (locale === "fr") return fr_verify_ticket_not_found_title(inputs)
	if (locale === "de") return de_verify_ticket_not_found_title(inputs)
	if (locale === "ja") return ja_verify_ticket_not_found_title(inputs)
	if (locale === "zh") return zh_verify_ticket_not_found_title(inputs)
	if (locale === "ar") return ar_verify_ticket_not_found_title(inputs)
	if (locale === "id") return id_verify_ticket_not_found_title(inputs)
	if (locale === "it") return it_verify_ticket_not_found_title(inputs)
	if (locale === "ru") return ru_verify_ticket_not_found_title(inputs)
	if (locale === "pt") return pt_verify_ticket_not_found_title(inputs)
	return ko_verify_ticket_not_found_title(inputs)
});